import { unitInstanceFromStep } from '@cards/engine';
import { cardRef, defineGameCard, onResolve, planningTargets, targetStep, unitTarget, } from '../authoring/index.js';
export const HuntersNetCard = defineGameCard({
    id: 'hunters_net',
    gameplay: {
        type: 'SPELL',
        cost: 2,
        planning: planningTargets([
            targetStep('target', unitTarget({
                side: 'enemy', cardTypes: ['UNIT'], cardinality: { min: 1, max: 1 },
            })),
        ]),
    },
    presentation: {
        name: 'Сеть ловчего',
        description: 'Выбранный вражеский боец пропускает атаку в этом раунде.',
        glyph: {
            colors: ['#653D2E', '#10213A', '#543027', '#7E4D36', '#7E4D36'],
            rows: [
                '....................',
                '.12..............23.',
                '.2222..........2222.',
                '..2122333221113212..',
                '..222....21....22...',
                '...21....242...22...',
                '...2.12.12.22.222...',
                '...2..21....212.2...',
                '...2.23.1142322.2...',
                '...2.12.33342.2.2...',
                '....22.241443..3....',
                '...222.334333..22...',
                '...2.12243442.222...',
                '...2..212443312.2...',
                '...2.243....132.2...',
                '..2222..1..1..2222..',
                '..211...2222...11...',
                '.221322222222221322.',
                '.322............223.',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef('hunters_net')],
    abilities: [onResolve((ctx) => {
            const targetId = unitInstanceFromStep(ctx.plan?.selections ?? [], 'target');
            const target = targetId === undefined ? null : ctx.q.instance(targetId);
            if (ctx.self === undefined || target?.zone !== 'board'
                || target.controllerId === ctx.self.controllerId || ctx.q.cardType(target.id) !== 'UNIT')
                return;
            ctx.ops.addEffect({
                defId: HuntersNetCard.id,
                scope: { kind: 'unit', instanceId: target.id },
                sourceId: ctx.self.id,
                duration: 1,
                persistent: true,
                vars: { attackPermission: 'prohibit' },
            });
        })],
    ui: {
        mechanics: ['cannot_attack'],
        planning: { steps: { target: { label: 'Выберите вражеского бойца' } } },
        effectStatusProviders: [(_context, effects) => {
                const effect = effects[0];
                if (effect === undefined)
                    return [];
                const count = effects.length;
                return [{
                        id: 'hunters-net',
                        symbol: '⌗',
                        label: count === 1 ? 'Сеть ловчего' : `Сеть ловчего ×${count}`,
                        description: 'Не атакует в этом раунде.',
                        tone: 'negative',
                    }];
            }],
    },
});
//# sourceMappingURL=hunters_net.js.map